import { FC } from 'react'

import styled from 'styled-components'

import { colors, device } from 'src/Helpers/constants.ts'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  gap: 10px;
  padding: 10px;
  width: 100%;

  @media ${device.tabletMax} {
    display: none;
  }
`

const ParametersContainer = styled.div`
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 1.5fr 0.5fr 3fr 0.5fr;
  width: 100%;
`

const Parameter = styled.div`
  font-size: 12px;
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${colors.thirdGray};
  font-weight: 600;
  justify-content: center;
  flex-shrink: 0;
`

export const TableHeader: FC = () => {
  return (
    <Container>
      <ParametersContainer>
        <Parameter>Наименование</Parameter>
        <Parameter>Цена</Parameter>
      </ParametersContainer>
    </Container>
  )
}
